import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import './portcoForm.css';
import "../../common/css/protagonistForm.css";
import { UpdatePortfolioCompany } from '../../common/api/PortcoAPIHelper'; // Import the API helper


function PortcoForm({ onSubmit, editData, onClear }) {
  const { register, handleSubmit, watch, reset, setValue, formState: { errors } } = useForm();
  const [saveMessage, setSaveMessage] = useState(null);

  function resetForm() {
    reset({
        portcoId: '',
        legalName: '',
        companyName: '',
        pitchbookId: '',
        websiteUrl: '',
        websiteBlurb: '',
        showOnWebsite: false,
        highlightOnWebsite: false,
    });
}

  useEffect(() => {
    if (editData) {
      setValue('portcoId', editData.portcoId);
      setValue('legalName', editData.legalName);
      setValue('companyName', editData.companyName);
      setValue('pitchbookId', editData.pitchbookId);
      setValue('websiteUrl', editData.websiteUrl);
      setValue('websiteBlurb', editData.websiteBlurb);
      setValue('showOnWebsite', editData.showOnWebsite);
      setValue('highlightOnWebsite', editData.highlightOnWebsite);
      setSaveMessage(null);
    } else {
      resetForm();
    }
  }, [editData, setValue, reset]);

  const handleClear = () => {
    resetForm();
    if (editData) {
      onClear();
    }
  };
  const portcoId = watch('portcoId');
  const formSubmitHandler = async (data) => {
    try {
      const { portcoId, companyName, legalName, pitchbookId, websiteUrl, websiteBlurb, showOnWebsite } = data;
      const responsePromise = await UpdatePortfolioCompany(portcoId, companyName, legalName, pitchbookId, websiteUrl, websiteBlurb, showOnWebsite);
      const response = await responsePromise;

      if (response && response.status === 200) {
        setSaveMessage('Successfully saved the company.');
        resetForm();
        onSubmit();  // New line
      } else {
        setSaveMessage('There was a problem saving the company. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error);
      setSaveMessage('There was a problem saving the company. Please try again.');
    }
    resetForm();
  }

  return (
    <form className="prot-admin-form" onSubmit={handleSubmit(formSubmitHandler)}>
      {editData ? (
        <div className="form-edit-message">Editing Portco Id : {editData.portcoId}</div>
      ) : (
        <div className="form-edit-message">(Create new Portfolio Company)</div>
      )}

      <input
        type="hidden" id="portcoId"
        {...register("portcoId")}
      />

      <div className="form-group">
        <label htmlFor="legalName">Company legal name</label>
        <input
          id="legalName"
          type="text"
          {...register("legalName", { required: true })}
          placeholder="Company legal name"
          className={errors.legalName ? "form-field-error" : ""}
        />
        {errors.legalName && <span className="error-message">This field is required</span>}
      </div>
      <div className="form-group">
        <label htmlFor="companyName">Company name</label>
        <input
          id="companyName"
          type="text"
          {...register("companyName", { required: true })}
          placeholder="Company name"
          className={errors.companyName ? "form-field-error" : ""}
        />
        {errors.companyName && <span className="error-message">This field is required</span>}
      </div>
      <div className="form-group">
        <label htmlFor="pitchbookId">Pitchbook Id</label>
        <input
          id="pitchbookId"
          type="text"
          {...register("pitchbookId", { required: true })}
          placeholder="Pitchbook Id"
          className={errors.pitchbookId ? "form-field-error" : ""}
        />
        {errors.pitchbookId && <span className="error-message">This field is required</span>}
      </div>
      <div className="form-group">
        <label htmlFor="websiteUrl">Website url</label>
        <input
          id="websiteUrl"
          type="url"
          {...register("websiteUrl", { required: true })}
          placeholder="Website url"
          className={errors.websiteUrl ? "form-field-error" : ""}
        />
        {errors.website && <span className="error-message">This field is required</span>}
      </div>
      <div className="form-group">
        <label htmlFor="websiteBlurb">Website Blurb</label>
        <textarea
          id="websiteBlurb"
          rows="7"
          {...register("websiteBlurb", { required: true })}
          placeholder="Website Blurb"
          className={errors.websiteBlurb ? "form-field-error" : ""}
        />
        {errors.websiteBlurb && <span className="error-message">This field is required</span>}
      </div>
      <div className="checkbox-one">
        <input
          id="showOnWebsite"
          type="checkbox"
          {...register("showOnWebsite")}
          defaultChecked={false}
        />
        <label htmlFor="showOnWebsite">Show on public website</label>
      </div>
      <div className="checkbox-one">
        <input
          id="highlightOnWebsite"
          type="checkbox"
          {...register("highlightOnWebsite")}
          defaultChecked={false}
        />
        <label htmlFor="highlightOnWebsite">Highlight on public website</label>
      </div>
      <div className="buttons">
        <button className="ra__protAdminform_button" type="submit">Save</button>
        <button className="ra__protAdminform_button" type="button" onClick={handleClear}>Clear</button>
    </div>
    {saveMessage && <div className="save-message">{saveMessage}</div>}
    </form>
  );
}

export default PortcoForm;
